<template>
	<div class="grid seatview">
		<div class="">
			<div class="grid seat active">
	            <span class="grid id">{{$store.state.ombrelloni.ombrelloni[0].ombrid}}</span>
	            <span class="grid name" v-if="hotel.seatview.guest">Mario Rossi</span>
	            <span class="grid stay" v-if="hotel.seatview.stay">{{stay}}</span>
	            <span class="grid items" v-if="hotel.seatview.items">
	              <span v-for="(item, index) in $store.state.hotels.activehotel.items" :key="index" v-html="item.icon"></span>
	            </span>
	            <span class="grid room" v-if="hotel.seatview.room && $store.state.hotels.activehotel.settings.room" :class="{onlyroom: !hotel.seatview.guest && !hotel.seatview.stay && !hotel.seatview.items}">101</span>
	          </div>
		</div>
		<div class="grid options">
			<!-- {{hotel.seatview}} -->
			<div>
				<div v-for="(option, index) in hotel.seatview" :key="index" class="grid option">
					<!-- {{index}} - {{option}} -->
					<!-- {{ $t("message.hello") }} -->
					<span>{{ $t("message." + index) }}</span>
					<el-switch
					  v-model="hotel.seatview[index]"
					  active-color="#13ce66"
					  inactive-color="#ddd"
					  :disabled="index === 'ombrid'">
					</el-switch>
				</div>
			</div>
			<button class="btn green" style="margin-top: 48px;" @click="$store.dispatch('hotels/updateHotel', $store.state.hotels.activehotel), $emit('close')"><unicon name="save" fill="#fff" /> Salva impostazioni</button>
		</div>
	</div>
</template>

<script>
// import _ from 'lodash'
import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
	name: 'SetSeatView',
	// mixins: [helper],
	props: {
		hotel: Object
	},
	data () {
		return {
			changes: false,
		}
	},
	methods: {
		show (section) {
			console.log(section)
			this.$emit('open', section)
		},
		save () {
			console.log('save')
			// this.$store.dispatch('hotels/updateHotel', this.hotel)
		}
	},
	filters: {
	},
	watch: {
	},
	computed: {
		stay () {
			return moment().format('DD.MM.YYYY')  + ' - ' + moment().add(7, 'd').format('DD.MM.YYYY')
		}
	},
	beforeMount () {
	},
	mounted () {
	},
	beforeDestroy () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
